import React,{useEffect, useMemo} from 'react';
import "./CustomDecision.css";
import Header from "../../../components/Header";
import Remarks from "../../../components/Remarks/Remarks";
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import useAuth from '../../../../customHooks/useAuth';
import { toast } from 'react-toastify';
import { baseUrl } from '../../../../common/baseUrl';
import axiosInstance from '../../../../axiosInstance/axiosInstance';


export default function CustomDecision() {


    const navigate = useNavigate();
    const location = useLocation();
  
    const bookedRoomId = location.state?.bookedRoomId || "";
    const bookingId = location.state?.bookingId || "";
    const requestId = location.state?.requestId || "";
    const userId = location.state?.userId || "";
    const status = location.state?.status || "";
    const Data = location.state?.Data || {};
  
  
    useAuth();

    // Check Id's
    useEffect(()=>{
        const checkId = ()=>{
            if(bookedRoomId==="" || bookingId===""){
                navigate("/bookings");
            }
        }
        checkId();
    },[bookingId,bookedRoomId,navigate])



    // This is used to format the status and remove underscore
    const formattedStatus = useMemo(() => {
        return  status.replace('_', ' ');
    }, [status]);


    // Close Request
    const closeRequest = async()=>{
    try{
        const response = await axiosInstance.put(`/api/v1/users/${userId}/guest-requests/${requestId}/close`);
        // console.log("Request Cancelled : ",response.data);

        toast.success("Custom Request Cancelled Successfully");
        navigate("/bookings",{state : {activeRequests : "requests"}});
    }catch(error){
        toast.error(error.response.data.message);
        console.log(error);
    }
  }
    
  
    return (
    <div className='customDecision'>
        <Header title="Custom Request" />

        <div className='custom-view'>
            <div className='custom-status'>
                <h4>{formattedStatus}</h4>
            </div>
            <div className='custom-data'>
                <h4>Request Details</h4>
                <div className='custom-inp'>
                    <h5>{Data.request_details}</h5>
                </div>
            </div>
        </div>
        
        {Data.remarks && 
            <Remarks para={Data.remarks} />
        }
       
        { !(status === "Completed_Hotel" || status === "Declined_Hotel" || status === "Declined_Guest" || status === "Closed_Hotel" || status === "Closed_Guest") && (
            <div className='custom-btn'>
                <button onClick={closeRequest}>Cancel Request</button>
            </div>
        )}
    
    
    </div>
  )
}
